<template>
    <div>
        <Configurator></Configurator>
    </div>
</template>

<script>
    import Configurator from '../components/configurator/index.vue'
    
    export default {
        components: {
            Configurator
        }
    }
</script>

<style scoped lang="scss">
</style>